import { ILogger } from '@cian/logger/shared';

import { TRequestDiagnostics, TRequestSource } from './types';

type TLogPublicApiEventParams = {
  /** Событие, порождающее запросы к публичным ручкам: разрыв WS, запрос реконнекта и т.п. */
  event: string;
  source: TRequestSource;
  diagnostics?: TRequestDiagnostics;
  /** Поля, специфичные для события */
  details?: TRequestDiagnostics;
};

/**
 * Пишет в лог событие, предшествующее запросам к публичным ручкам чатов
 */
export function logPublicApiEvent(
  logger: ILogger,
  { event, source, diagnostics, details }: TLogPublicApiEventParams,
): void {
  logger.info(`[publicApi] ${event}`, {
    event,
    source,
    ...diagnostics,
    ...details,
  });
}
